// Generated Module Configuration
export const moduleConfig = {
  "moduleConfig": {
    "name": "New Module",
    "description": "",
    "size": "medium",
    "theme": "uplynk",
    "categories": {
      "Ads" : [
        {
          "title": "Tears of Steel",
          "description": "Ad Prerolls, Midrolls, Postrolls",
          "players": {
            "player1": {
              "title": "User 1",
              "url": "https://content.uplynk.com/bc0ca00361d84a9fa7373adecf61ec4f.m3u8?ad=demo&ad.preroll=1&ad.postroll=1",
            },
            "player2": {
              "title": "User 2",
              "url": "https://content.uplynk.com/bc0ca00361d84a9fa7373adecf61ec4f.m3u8?ad=demo&ad.preroll=1&ad.postroll=1",
            },
            "player3": {
              "title": "User 3",
              "url": "https://content.uplynk.com/bc0ca00361d84a9fa7373adecf61ec4f.m3u8?ad=demo&ad.preroll=1&ad.postroll=1",
            },
            "player4": {
              "title": "User 4",
              "url": "https://content.uplynk.com/bc0ca00361d84a9fa7373adecf61ec4f.m3u8?ad=demo&ad.preroll=1&ad.postroll=1",
            },
          }
        },
        {
          "title": "Tears of Steel",
          "description": "Midrolls Only",
          "players": {
            "player1": {
              "title": "User 1",
              "url": "https://content.uplynk.com/bc0ca00361d84a9fa7373adecf61ec4f.m3u8?ad=demo",
            },
            "player2": {
              "title": "User 2",
              "url": "https://content.uplynk.com/bc0ca00361d84a9fa7373adecf61ec4f.m3u8?ad=demo",
            },
            "player3": {
              "title": "User 3",
              "url": "https://content.uplynk.com/bc0ca00361d84a9fa7373adecf61ec4f.m3u8?ad=demo",
            },
            "player4": {
              "title": "User 4",
              "url": "https://content.uplynk.com/bc0ca00361d84a9fa7373adecf61ec4f.m3u8?ad=demo",
            },
          }
        },
      ],
      "Playlist": [
        {
          "title": "6 Asset Playlist",
          "description": "Smartplay Asset Stitching",
          "players": {
            "player1": {
              "title": "Playlist",
              "url": "https://content.uplynk.com/d3454fd3aade4bc38d6fed1097e574dc,b671fd95ff9b4cb082c59626f0e2164d,1a78099440fd4bce80733566ef24c3c3,87b098e43148424d949115c795d122eb,4f61c3e547b7434d82773a2ea463f11a/multiple.m3u8",
            },
            "player2": {},
            "player3": {
              "title": "Single Video",
              "url": "https://content.uplynk.com/d3454fd3aade4bc38d6fed1097e574dc.m3u8",
            },
            "player4": {},
          }
        },
        {
          "title": "Pre & Post Bumpers",
          "description": "Smartplay Asset Stitching",
          "players": {
            "player1": {
              "title": "Pre & Post Bumpers",
              "url": "https://content.uplynk.com/702834618c2646b09a173e3cf475b6b4,d3454fd3aade4bc38d6fed1097e574dc,702834618c2646b09a173e3cf475b6b4/multiple.m3u8",
            },
            "player2": {},
            "player3": {
              "title": "No Bumpers",
              "url": "https://content.uplynk.com/d3454fd3aade4bc38d6fed1097e574dc.m3u8",
            },
            "player4": {},
          }
        },
      ],
      "Restrict": [
        {
          "title": "10 Minute Preview",
          "description": "Limit Segments in Manifest",
          "players": {
            "player1": {
              "title": "10 Minute Preview",
              "url": "https://content.uplynk.com/d3726d2cf23d41cd8aed4e89c4f27c54.m3u8?stop=600",
            },
            "player2": {},
            "player3": {
              "title": "Full Program",
              "url": "https://content.uplynk.com/d3726d2cf23d41cd8aed4e89c4f27c54.m3u8",
            },
            "player4": {},
          }
        },
        {
          "title": "6 Minute Extract",
          "description": "Limit Segments in Manifest",
          "players": {
            "player1": {
              "title": "6 Minute Extract",
              "url": "https://content.uplynk.com/d3726d2cf23d41cd8aed4e89c4f27c54.m3u8?start=2000&stop=2360",
            },
            "player2": {},
            "player3": {
              "title": "Full Program",
              "url": "https://content.uplynk.com/d3726d2cf23d41cd8aed4e89c4f27c54.m3u8",
            },
            "player4": {},
          }
        },
        {
          "title": "144p Resolution Limit",
          "description": "Limit Resolutions in Manifest",
          "players": {
            "player1": {
              "title": "144p Resolution Limit",
              "url": "https://content.uplynk.com/d3726d2cf23d41cd8aed4e89c4f27c54.m3u8?resolutions=0-150",
            },
            "player2": {},
            "player3": {
              "title": "All Resolutions",
              "url": "https://content.uplynk.com/d3726d2cf23d41cd8aed4e89c4f27c54.m3u8",
            },
            "player4": {},
          }
        },
      ],
      "Geoblocking": [
        {
          "title": "Deny Country",
          "description": "ISO Country Code Blocking",
          "players": {
            "player1": {
              "title": "Geoblocked",
              "url": "https://content.uplynk.com/d784119c317d45c7bda44a61b8258e8e.m3u8?geo.country.deny={ISO}",
            },
            "player2": {},
            "player3": {
              "title": "Unrestricted",
              "url": "https://content.uplynk.com/d784119c317d45c7bda44a61b8258e8e.m3u8",
            },
            "player4": {},
          }
        },
      ],
    }
  }
}